/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { IModuleProps, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IReviewModalViewProps } from '../../common/review-modal';
import { IWriteReviewViewProps } from './write-review';

const WriteReviewView: React.FC<IWriteReviewViewProps> = props => {
    const { heading, signInMessage, signInButton, modalToggle, reviewModal, moduleProps } = props;
    const isAuthenticated = props.context.request.user.isAuthenticated;
    return (
        <Module {...moduleProps}>
            {heading}
            {!isAuthenticated ? <>
                {signInMessage}
                {signInButton}
            </> : <>
                {modalToggle}
                {createReviewModal(reviewModal, moduleProps)}
            </>}
        </Module>
    );
};

const createReviewModal = (props: IReviewModalViewProps, moduleProps: IModuleProps): JSX.Element => {
    return (
        <Module {...props.modal} {...moduleProps}>
            {props.modalHeader}
            <Node {...props.modalBody}>
                <Node {...props.form}>
                    <Node {...props.inputRow}>
                        {props.rating}
                        {props.ratingLabel}
                    </Node>
                    <Node {...props.inputRow}>
                        {props.titleLabel}
                        {props.titleInput}
                    </Node>
                    <Node {...props.inputRow}>
                        {props.textLabel}
                        {props.textInput}
                    </Node>
                    {props.privacyPolicyUrl}
                    {props.error}
                </Node>
            </Node>
            <Node {...props.modalFooter}>
                {props.submitButton}
                {props.cancelButton}
            </Node>
        </Module>
    );
};

export default WriteReviewView;
